import { Typography, PageHeader, Affix, Card } from "antd";

export default function Header(props) {
  // Props
  const { title, subTitle, routes, actions, disableAffix = false } = props;

  // Antd
  const { Title } = Typography;

  const pageHeader = (
    <PageHeader
      title={<Title level={5}>{title}</Title>}
      extra={actions}
      breadcrumb={routes}
    />
  );

  if (disableAffix) {
    return pageHeader;
  }

  return <Affix>{pageHeader}</Affix>;
}
